import * as actions from '../actionTypes';

import { showLoader, hideLoader } from '../../actions/shared/loader';
import { showError, setErrorObject } from '../../actions/shared/HTTPError';
import endPoints from '../../modules/ajio-util/endpoints';
import fetcher from '../../modules/ajio-fetch';
import { readCookie } from '../../components/common/Cookie';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  tokenReCreateParser
} from '../../modules/ajio-fetch/utils';
import { errorProcessor as cartErrorProcessor } from '../../modules/ajio-fetch/errorProcessor';
import { setCartItem } from './cartItem';
import { setCartData } from './cartData';

import { createAnonymousToken, setToken } from '../../actions/authUser';

import {
  setCart,
  cartItemData,
  getCartSuccess,
  getCartFail,
  updateToCartError,
  setVouchers,
  removeVoucher,
  setAjioWalletEarnData,
  setInternalWallet,
  giftItemData
} from './cartActionCreator';

import { getUserName } from './cart';
import { autoApplyVoucherTracking } from '../../constants/cartConstants';
import { setGSTCartDetails } from './gst';

export function getVouchers() {
  return dispatch => {
    dispatch(showLoader('cart-loader'));
    const apiEndPoint = `/api/cart/vouchers-sorted`;

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(hideLoader('cart-loader'));
        dispatch(setVouchers(response));
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        const user = readCookie('U');
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              getVouchers()(dispatch);
              dispatch(hideLoader('cart-loader'));
            })
            .catch(() => {
              dispatch(setErrorObject(errorObj));
              dispatch(hideLoader('cart-loader'));
            });
        });
      });
  };
}

export function clearVoucher() {
  return dispatch => {
    dispatch(hideLoader('animated-popup-loader'));
    dispatch(removeVoucher());
  };
}

export function applyVoucher(voucherCode, client_type, voucherCallback) {
  return dispatch => {
    dispatch(showLoader('cart-loader'));
    const apiEndPoint = `/api/cart/apply-voucher`;

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify({ voucherId: voucherCode, device: { client_type } }),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          code = '',
          guid = '',
          refreshChecksum = '',
          loyaltyPointsInfo = '',
          otpValidationRequired = true,
          backendInternalWalletFlag = false
        } = response;
        let { internalWallets = [] } = response;
        internalWallets = mapInternalWallet(internalWallets);
        dispatch(
          setInternalWallet({
            internalWallets,
            refreshChecksum,
            loyaltyPointsInfo,
            otpValidationRequired,
            backendInternalWalletFlag
          })
        );
        let cart = {};

        const userName = getUserName();
        if (userName.toLowerCase().trim() === 'anonymous') {
          cart.type = 'anonymous';
          cart.id = guid;
        } else {
          cart.type = 'authenicated';
          cart.id = code;
        }

        const messageBar = {
          errorType: 'info',
          message: 'Your coupon has been redeemed successfully'
        };

        cart = setCartData(cart, response) || {};
        const cartItem = setCartItem(response, true) || [];
        dispatch(cartItemData(cartItem));
        dispatch(setCart(cart));
        dispatch(getCartSuccess());
        dispatch(setGSTCartDetails(cart?.gstDetails || {}));
        voucherCallback ? voucherCallback() : undefined;

        dispatch(hideLoader('cart-loader'));
        dispatch(setErrorObject(messageBar));
        const timeout = setTimeout(() => {
          dispatch(setErrorObject({}));
          clearTimeout(timeout);
        }, 5000);
        return Promise.resolve(response);
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        const user = readCookie('U');
        return errorParser(error, statusCode).then((errorObj = {}) => {
          return tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              return applyVoucher(voucherCode, client_type, voucherCallback)(dispatch);
            })
            .catch(err => {
              errorObj.originator = 'voucher';
              dispatch(hideLoader('cart-loader'));
              dispatch(setErrorObject(errorObj));
              return Promise.reject(errorObj);
            });
        });
        // return Promise.reject(error);
      });
  };
}

export function resetVoucher(voucherCode, voucherCallback) {
  return dispatch => {
    dispatch(showLoader('cart-loader'));
    const apiEndPoint = `/api/cart/reset-voucher`;

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify({ voucherId: voucherCode }),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const {
          code = '',
          guid = '',
          refreshChecksum = '',
          loyaltyPointsInfo = '',
          otpValidationRequired = true,
          backendInternalWalletFlag = false
        } = response;
        let { internalWallets = [] } = response;
        internalWallets = mapInternalWallet(internalWallets);
        dispatch(
          setInternalWallet({
            internalWallets,
            refreshChecksum,
            loyaltyPointsInfo,
            otpValidationRequired,
            backendInternalWalletFlag
          })
        );
        let cart = {};
        const userName = getUserName();
        if (userName.toLowerCase().trim() === 'anonymous') {
          cart.type = 'anonymous';
          cart.id = guid;
        } else {
          cart.type = 'authenicated';
          cart.id = code;
        }
        cart = setCartData(cart, response) || {};
        const cartItem = setCartItem(response, true) || [];
        dispatch(cartItemData(cartItem));
        dispatch(setCart(cart));
        dispatch(getCartSuccess());
        dispatch(setGSTCartDetails(cart?.gstDetails || {}));

        voucherCallback ? voucherCallback() : undefined;

        dispatch(hideLoader('cart-loader'));

        const messageBar = {
          errorType: 'info',
          message: 'Coupon Removed'
        };
        dispatch(setErrorObject(messageBar));
        const timeout = setTimeout(() => {
          dispatch(setErrorObject({}));
          clearTimeout(timeout);
        }, 5000);
      })
      .catch(error => {
        const statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              resetVoucher(voucherCode)(dispatch);
            })
            .catch(() => {
              dispatch(setErrorObject(errorObj));
              dispatch(hideLoader('cart-loader'));
              return Promise.reject(errorObj);
            });
        });
      });
  };
}

export function showBestVoucherApplied(message) {
  return dispatch => {
    const messageBar = {
      errorType: 'info',
      message
    };
    dispatch(setErrorObject(messageBar));
    const {
      EVENT_CATEGORY,
      ADDED_EVENT_ACTION,
      ADDED_EVENT_LABEL,
      VOUCHER_APPLIED_MESSAGE_TIMEOUT
    } = autoApplyVoucherTracking;
    ga('send', {
      hitType: 'event',
      eventCategory: EVENT_CATEGORY,
      eventAction: ADDED_EVENT_ACTION,
      eventLabel: ADDED_EVENT_LABEL
    });
    const timeout = setTimeout(() => {
      dispatch(setErrorObject({}));
      clearTimeout(timeout);
    }, VOUCHER_APPLIED_MESSAGE_TIMEOUT);
  };
}

function mapInternalWallet(internalWallets) {
  return internalWallets.map(wallet =>
    wallet.code === 'AJIO_CASH_WALLET' && wallet.multipleWalletEnabledAmount <= 0
      ? { ...wallet, isSelected: false }
      : wallet
  );
}
